import type { FirebaseOptions } from "firebase/app";

/**
 * Shared Firebase configuration sourced from Vite environment variables.
 *
 * Keeping this in a small utility module allows lightweight consumers (like
 * the public landing apps) to reference the config without eagerly importing
 * the hefty Auth/Firestore SDK bundles from `api/firebase`.
 */
export const firebaseConfig: FirebaseOptions = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
};

/**
 * While we only ever initialise a single default app, exporting the name keeps
 * call sites honest if we later decide to use named instances.
 */
export const DEFAULT_FIREBASE_APP_NAME: string | undefined = undefined;
